export const promotionImage = {
  BUTTON: 'PromotionImage.Button'
}
